import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Mic } from "lucide-react";
import api from "@/lib/api";
import { CamRecorder } from "@/components/podcast/CamRecorder";
import { pickMime } from "@/components/podcast/media";

export default function PodcastGuestPage() {
  const { token } = useParams();
  const [e, setE] = useState(null);
  const [done, setDone] = useState(false);
  useEffect(() => { api.get(`/api/podcast/guest/${token}`).then(r => { setE(r.data); setDone(r.data.status === "ready"); }).catch(() => setE(false)); }, [token]);
  const begin = async () => { const { data } = await api.post(`/api/podcast/guest/${token}/start`, { mime: pickMime() || "video/webm" }); return { eid: data.id, token }; };
  return (
    <div className="min-h-screen bg-slate-950 text-white py-10 px-4" data-testid="podcast-guest-page"><div className="max-w-3xl mx-auto space-y-5">
      <img src="/brand/directory-logo.webp" alt="The ShopAdvisor" className="w-40 h-auto" />
      {e === null && <Loader2 className="w-6 h-6 animate-spin" />}
      {e === false && <p data-testid="guest-invalid">This recording link isn't valid.</p>}
      {e && <>
        <div><p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-400 flex items-center gap-1"><Mic className="w-4 h-4" />The ShopAdvisor Podcast</p>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mt-1" data-testid="guest-title">{e.title}</h1>
          <p className="text-white/70 mt-2">Hi {e.guest_name.split(" ")[0]}! {e.prompt || "Tell us your story in your own words."}</p></div>
        {done ? <p className="text-lg font-bold text-green-400" data-testid="guest-done">Thank you — your video was sent to our team!</p>
          : <div className="bg-white text-slate-900 rounded-3xl p-4"><CamRecorder begin={begin} label={() => ({ title: e.guest_name, sub: e.shop_name || "The ShopAdvisor Podcast" })} onDone={() => setDone(true)} maxMins={15} /></div>}
        <p className="text-xs text-white/40">Tips: find a quiet spot, face a window or light, and hold your phone sideways.</p>
      </>}
    </div></div>
  );
}
